'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createPartnerSelector = function createPartnerSelector(key) {
  return function (state) {
    return state.partner.get(key);
  };
};

var getPartnerPrivacy = exports.getPartnerPrivacy = createPartnerSelector('partnerPrivacyLink');
var getPartnerCompany = exports.getPartnerCompany = createPartnerSelector('partnerCompany');
var getPartnerRequestState = exports.getPartnerRequestState = createPartnerSelector('requestState');
var getDidShowPartnerPrivacy = exports.getDidShowPartnerPrivacy = createPartnerSelector('didShowPartnerPrivacy');
var getPartnerId = exports.getPartnerId = createPartnerSelector('partnerId');